import { Component, OnInit, Input } from '@angular/core';
import { NgxGalleryOptions, NgxGalleryImage } from 'ngx-gallery';
import { MitterService } from '../../../services/mitter.service';

@Component({
  selector: 'mitter-message-payload',
  templateUrl: './message-payload.component.html',
  styleUrls: ['./message-payload.component.css']
})
export class MessagePayloadComponent implements OnInit {
  @Input() message: any;
  @Input() galleryOptions: NgxGalleryOptions[];
  @Input() galleryImages: NgxGalleryImage[];
  mitter: any;

  isTextPayload : boolean;
  isImagePayload: boolean;
  isPrescriptionPayload: boolean;

  showTextPayload: boolean;
  showImagePayload: boolean;

  imgThumbnail: string;
  imgStandard: string;

  constructor(private mitterService: MitterService) {
    this.mitter = mitterService.getMitter();
  }

  ngOnInit() {
    this.isTextPayload = this.message.payloadType === 'mitter.mt.Text';
    this.isImagePayload = this.message.payloadType === 'mitter.mt.Image';
    this.isPrescriptionPayload = this.message.messageData &&
          this.message.messageData.length > 0 &&
          this.message.messageData.find(d => d.dataType === 'petcart.messageInfo') &&
          this.message.messageData.find(d => d.dataType === 'petcart.messageInfo').data.isPrescription;

    this.showTextPayload = !this.isPrescriptionPayload && this.isTextPayload;
    this.showImagePayload = !this.isPrescriptionPayload && this.isImagePayload;

    if (this.isImagePayload) {
      this.imgThumbnail = this.mitter.getMitterUrl() +
        this.message.messageData.find(e => e.dataType === 'text/uri-list').data.link.replace('$repr', 'base');
      this.imgStandard = this.mitter.getMitterUrl() +
        this.message.messageData.find(e => e.dataType === 'text/uri-list').data.link.replace('$repr', 'base');

      if (this.galleryImages) {
        this.galleryOptions[0].startIndex =
          this.galleryImages.map(galleryImage => galleryImage.big).indexOf(this.imgStandard);
      }
    }
  }

  processText(text) {
    return text.split('\n').join('<br/>');
  }

  getImageIndex() {

  }
}
